import {Delete, GET, POST} from "../util";

const inspectionUrl = "api/custom-ratings-inspection";
const operationUrl = "api/custom-ratings-operation";

const url = {
    inspection: {
        config: `${inspectionUrl}/config`,
        listCustomRatings: `${inspectionUrl}/list`,
        customRating: `${inspectionUrl}/custom-rating/:companyId`,
    },
    operation: {
        saveConfig: `${operationUrl}/save-config`,
        saveCustomRating: `${operationUrl}/save-custom-rating/:companyId`,
        deleteCustomRating: `${operationUrl}/delete-custom-rating/:companyId`,
    }
};

const customRatingsApi = {
    inspection: {
        getConfig: () => {
            return GET(url.inspection.config);
        },
        listCustomRatings: (params = {}) => {
            return POST(url.inspection.listCustomRatings, params);
        },
        getCustomRating: (companyId) => {
            return GET(url.inspection.customRating.replace(":companyId", companyId));
        }
    },
    operation: {
        saveConfig: (data) => {
            return POST(url.operation.saveConfig, data);
        },
        saveCustomRating: (companyId, data) => {
            return POST(url.operation.saveCustomRating.replace(":companyId", companyId), data);
        },
        deleteCustomRating: (companyId) => {
            return Delete(url.operation.deleteCustomRating.replace(":companyId", companyId));
        },
    }
};

export {
    customRatingsApi
};
